import { render, staticRenderFns } from "./RevertInvoices.vue?vue&type=template&id=794b371a&scoped=true"
import script from "./RevertInvoices.vue?vue&type=script&lang=js"
export * from "./RevertInvoices.vue?vue&type=script&lang=js"
import style0 from "./RevertInvoices.vue?vue&type=style&index=0&id=794b371a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b371a",
  null
  
)

export default component.exports